import { render, staticRenderFns } from "./EmailBox.vue?vue&type=template&id=e2943f5a&"
import script from "./EmailBox.vue?vue&type=script&lang=js&"
export * from "./EmailBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports